import { render } from "./OTPVerify.vue?vue&type=template&id=57608b00"
import script from "./OTPVerify.vue?vue&type=script&lang=js"
export * from "./OTPVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__